let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ktWpd")).then(() => parcelRequire('1W0jl'));